import React from 'react'
import Main from "../../Layout/Main"
import Tittle from '../../Components/attend/Tittle'
import News from '../../Components/attend/News'
import Subscribe from '../../Components/attend/Subscribe'
const Attend = () => {
  return (
    <Main>
<Tittle/>
<News/>
<Subscribe/>
    </Main>
  )
}

export default Attend